import { jsxs as g, jsx as l } from "react/jsx-runtime";
import { E as v, S as d } from "./icons.types-0722eef5.js";
function p({ title: a, titleId: s, size: c, width: h, height: n, extended: r = !1, ...o }) {
  const i = r ? v : d, t = c ? i[c] : h || i[r ? "s" : "l"], e = c ? i[c] : n || i[r ? "s" : "l"];
  return /* @__PURE__ */ g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: t,
      height: e,
      "aria-labelledby": s,
      ...o,
      children: [
        a ? /* @__PURE__ */ l("title", { id: s, children: a }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Image_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M60.84 10.8h-49.5C9 10.8 7.2 12.6 7.2 14.76v42.3c0 2.16 1.8 4.14 4.14 4.14h49.5c2.16 0 3.96-1.98 3.96-4.14v-42.3c0-2.16-1.8-3.96-3.96-3.96ZM10.8 14.76c0-.18.18-.36.36-.36h49.5c.36 0 .54.18.54.36v30.636l-8.174-8.246c-1.211-1.298-3.16-1.52-4.708-.479l-8.693 6.55L28 27.9a3.591 3.591 0 0 0-2.712-1.337c-1.091.003-2.072.414-2.798 1.229L10.8 41.377V14.76ZM60.75 57.6H11.16a.361.361 0 0 1-.36-.36V46.83l14.362-16.712L36.79 45.439c1.179 1.464 3.247 1.777 4.881.675l8.763-6.469L61.2 50.51v6.64a.45.45 0 0 1-.45.45ZM46.8 32.4c3.96 0 7.2-3.24 7.2-7.02 0-3.78-3.24-7.02-7.2-7.02s-7.2 3.24-7.2 7.02c0 3.78 3.24 7.02 7.2 7.02Zm0-10.62c1.98 0 3.6 1.62 3.6 3.42 0 1.8-1.62 3.42-3.6 3.42S43.2 27 43.2 25.2c0-1.8 1.62-3.42 3.6-3.42Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Image_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as Image
};
